module.exports = __webpack_public_path__ + "img/logo alterno color negro.007e39a8.png";